import React from "react";

const CodeSnippets = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M10.047 27.038 2 18.311l8.047-8.726 2.036 1.976-6.201 6.75 6.2 6.75-2.035 1.977ZM25.953 27.038l-2.036-1.977 6.201-6.75-6.2-6.75 2.035-1.976L34 18.312l-8.047 8.726ZM22.267 8.393l-5.729 19.163-2.805-.393L19.462 8l2.805.393Z"
            fill={fill}
        />
    </svg>
);

export default CodeSnippets;